export default "__VITE_ASSET__aa6f21fe__"